module.exports = __webpack_public_path__ + "static/mobileNotifications-61065f2b874b2d97f50705411a60294a.png";